export class MenuItem {
  nome: string = null;
  link: string = null;
  hint: string = null;

  constructor(d?) {
    if (d) {
      this.nome = d.nome ? d.nome : null;
      this.link = d.link ? d.link : null;
      this.hint = d.hint ? d.hint : null;
    }
  }
}
